import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=7df6b8db&scoped=true"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=7df6b8db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6b8db",
  null
  
)

export default component.exports